import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";

import DesktopHeader from "./desktopHeader";
import { FaBars } from "@react-icons/all-files/fa/FaBars";
import { FiChevronDown } from "@react-icons/all-files/fi/FiChevronDown";
import { IoIosArrowDown } from "@react-icons/all-files/io/IoIosArrowDown";
import Logo from "../../assets/images/LKCTC-LOGO.png";
import RTI_Disclosure from "../../assets/pdf/RTIDisclosure.pdf";
import SearchBar from "../SearchBar";
import StudentMentoring from "../../pages/StudentMentoring";
// import antiRagging from "../../assets/pdf/ANTI_RAGGING_NEW.pdf";
import antiRagging from "../../assets/pdf/newAntiRagging.pdf";
import ar_helpline from "../../assets/pdf/AR_Helpline.pdf";
import data from "../../assets/jsonFiles/navLink.json";
import equalOpp from "../../assets/pdf/EOC_NEW.pdf";
import establishment from "../../assets/pdf/INTERAL_COMPLAINT.pdf";
import helpline from "../../assets/pdf/Women_helpline.pdf";
import iccWomen from "../../assets/pdf/ICC.pdf";
import iicCell from "../../assets/pdf/IIC.pdf";
import importantInformation from "../../assets/pdf/Statutory Declaration.pdf";
import internalCommitte from "../../assets/pdf/IC.pdf";
import iqac from "../../assets/pdf/IQAC_NEW.pdf";
import map from "../../assets/pdf/Map.pdf";
import { motion } from "framer-motion";
import nirf from "../../assets/pdf/NIRFMerged.pdf";
import scst from "../../assets/pdf/SC_ST_Committee.pdf";
import sgrc from "../../assets/pdf/STUDENT_GRIEVANCE_NEW.pdf";
import styles from "./index.module.css";

// import iicCell from "../../assets/pdf/ICC.pdf";

// import sgrc from "../../assets/pdf/SGRC.pdf";

// import approvedIntake from "../../assets/pdf/APPROVED-INTAKE.pdf";

// import antiRagging from "../../assets/pdf/Anti Ragging.pdf";

//import grievance from "../../assets/pdf/SGRC.pdf";

// import SVG from "../.././assets/images/62de765b4d21ac26203c3874_Social-follow.svg";

const Header = () => {
  const [dropDown, setDropDown] = useState(false);
  const [dropAnim, setDropAnim] = useState([]);
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [color, setcolor] = useState(false);
  const [mobileMandatoryOpen, setMobileMandatoryOpen] = useState(false);
  const navigate = useNavigate();
  const handelDropDown = ({ e }) => {
    setDropAnim((current) => [...current, e]);
  };

  const listenScrollEvent = (e) => {
    if (window.scrollY > 70) {
      setcolor(true);
    } else {
      setcolor(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
  }, []);
  let ref = useRef();

  useEffect(() => {
    const handleClickSearchOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setDropDown(false);
        // if (dropDown && event.target.id !== "usernameButtonId") {
        // }
      }
    };
    if (dropDown)
      document.addEventListener("click", handleClickSearchOutside, true);
    return () => {
      document.removeEventListener("click", handleClickSearchOutside, true);
    };
  }, [dropDown]);

  const navLinks = [
    {
      title: "24 X 7 Women Helpline Number",
      // url: "/MandatoryDisclosure/WomenGrievance",
      pdf: helpline,
    },
    {
      title: "24 X 7 Anti-Ragging Helpline Number",
      // url: "/MandatoryDisclosure/WomenGrievance",
      pdf: ar_helpline,
    },
    {
      title: "Affiliation Order & EOA",
      url: "/MandatoryDisclosure/AffiliationOrder",
    },
    // {
    //   title: "Approved Intake",
    //   pdf: approvedIntake,
    // },
    {
      title: "IQAC",
      pdf: iqac,
    },
    {
      title: "IIC Cell",
      pdf: iicCell,
    },
    {
      title: "NIRF",
      // url: "/MandatoryDisclosure/WomenGrievance",
      pdf: nirf,
    },
    // {
    //   title: "Approval",
    //   url: "/MandatoryDisclosure/Approval",
    // },
    {
      title: "Student Grievance Portal",
      form: "https://docs.google.com/forms/d/e/1FAIpQLSeRPeIFUpwMqLewg13shb9gwndajahos3XbqR_km4gi4_wS3A/viewform",
    },
    {
      //title: "Statutory Declaration",
      //pdf: importantInformation,
    },
    {
      title: "Anti Ragging",
      pdf: antiRagging,
    },
    //{
    //title: "Grievance and OBUDSMAN",
    //pdf: grievance,
    //},
    {
      title: "Internal Complaint Committee",
      // pdf: establishment,
      pdf: iccWomen,
    },
    // {
    //   title: "Commitee (ICC)-Women Related",
    //   pdf: iccWomen,
    // },
    // {
    //   title: "Statutory Declaration",
    //   pdf: importantInformation,
    // },
    {
      title: "SC/ST Committee",
      pdf: scst,
    },
    {
      title: "Student Grievance Redressal Committee (SGRC)",
      pdf: sgrc,
    },
    {
      title: "Equal Opportunity Cell",
      pdf: equalOpp,
    },
    {
      title: "Internal Committee for differently abled Students",
      pdf: internalCommitte,
    },
    {
      title: "Map Longtitude and Latitude of the Institute",
      pdf: map,
    },
    // {
    //   title: "Women Grievance,Sexual Harassment and Grievance cell",
    //   // url: "/MandatoryDisclosure/WomenGrievance",
    //   pdf: helpline,
    // },
  ];
  if (dropDownOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = RTI_Disclosure;
    link.target = "_blank";
    link.rel = "noopener noreferrer"; // Security measure
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleIctem = () => {
    const link = document.createElement("a");
    link.href = "https://ictem-2025.onrender.com";
    link.target = "_blank";
    link.rel = "noopener noreferrer"; // Security measure
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleAdmission = () => {
    window.location.href = "https://www.lkctc.edu.in/Admission/AdmissionForm";
  };

  const handleProspectus = () => {
    const link = document.createElement("a");
    link.href = "https://tinyurl.com/lkctcprospectus2526";
    link.target = "_blank";
    link.rel = "noopener noreferrer"; // Security measure
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleMentoring = () => {
    navigate("/student-mentoring");
  };

  const handleFDP = () => {
    navigate("/fdp2025");
  };

  return (
    <div className="fixed z-[80] w-full">
      <div className=" h-full ">
        <div className="primary-bg-color  pt-2">
          {/* _________________Mandatory Popup_____________ */}
          <div className=" md:flex " ref={ref}>
            <div className="md:w-[80%] h-auto">
              <div className="marquee h-8 xs:h-9 md:h-8" style={{lineHeight: "2rem"}}>
                <div className="marquee--inner text-white">
                  <h1 className="whitespace-nowrap text-[12px] md:text-base lg:text-base font-semibold tracking-wide px-8">
                    🎓&nbsp;Admissions Open 2026-27&nbsp;|&nbsp;📞&nbsp;For Admission Call:&nbsp;
                    <a href="tel:+918847262500" className="text-yellow-300 font-bold hover:underline">+91-88472-62500</a>
                    &nbsp;&nbsp;⭐&nbsp;Apply Now and Secure Your Seat!
                  </h1>
                  <h1 className="whitespace-nowrap text-[12px] md:text-base lg:text-base font-semibold tracking-wide px-8">
                    🎓&nbsp;Admissions Open 2026-27&nbsp;|&nbsp;📞&nbsp;For Admission Call:&nbsp;
                    <a href="tel:+918847262500" className="text-yellow-300 font-bold hover:underline">+91-88472-62500</a>
                    &nbsp;&nbsp;⭐&nbsp;Apply Now and Secure Your Seat!
                  </h1>
                </div>
              </div>
            </div>
            <div className=" pr-3 font-bold z-40 hidden md:block">
              <div className="flex justify-between items-center gap-10 lg:gap-4">
                <a
                  href="tel:+918847262500"
                  className="hidden xl:flex items-center gap-2 bg-yellow-400 text-[#081C3A] text-sm font-extrabold px-3 py-1 rounded-full shadow-lg hover:bg-yellow-300 transition-all whitespace-nowrap"
                  title="Call for Admission"
                >
                  📞 +91-88472-62500
                </a>
                <div
                  className="cursor-pointer text-lg text-white md:text-md pl-5 w-[300px] md:w-[200px] lg:w-[250px] xl:w-[200px]"
                  onClick={() => handleAdmission()}
                >
                  Admissions 2026-27
                </div>
                {/* <div
                  className="cursor-pointer text-lg text-white md:text-md pl-5 w-[300px] md:w-[200px] lg:w-[250px] xl:w-[200px]"
                  onClick={() => handleProspectus()}
                >
                  Prospectus 2025-26
                  Student Mentoring
                </div> */}

                {/* <div
                  className="cursor-pointer text-lg text-white md:text-md pl-5 w-[300px] md:w-[200px] lg:w-[250px] xl:w-[200px]"
                  onClick={() => handleProspectus()}
                >
                  Student Mentoring
                </div> */}

                <div
                  className="cursor-pointer text-lg text-white md:text-md pl-5 w-[300px] md:w-[200px] lg:w-[250px] xl:w-[200px]"
                  onClick={handleMentoring}
                >
                  Student Mentoring
                </div>
                {/* <div
                  className="cursor-pointer text-lg text-white md:text-md pl-5 w-[300px] md:w-[200px] lg:w-[250px] xl:w-[200px]"
                  onClick={() => handleIctem()}
                >
                  ICTEM-2025
                </div> */}
                <div
                  className="cursor-pointer text-lg text-white md:text-md pl-5 w-[300px] md:w-[200px] lg:w-[250px] xl:w-[200px]"
                  onClick={() => handleDownload()}
                >
                  RTI Disclosure
                </div>

                {/* <div
                  className="cursor-pointer text-lg text-white md:text-md pl-5 w-[300px] md:w-[200px] lg:w-[250px] xl:w-[200px]"
                  onClick={handleFDP}
                >
                  FDP-2025
                </div> */}
                <div
                  className="cursor-pointer text-lg text-white md:text-md pl-5 w-[300px] md:w-[200px] lg:w-[250px] xl:w-[200px]"
                  onClick={() => setDropDown(!dropDown)}
                >
                  Mandatory Disclosure
                </div>
                <div
                  className=" mt-1 cursor-pointer text-white"
                  onClick={() => setDropDown(!dropDown)}
                >
                  <IoIosArrowDown className="text-lg font-bold" />
                </div>
              </div>
            </div>
            {dropDown && (
              <div
                className={`${!dropDown ? "hidden" : "flex flex-col"} ${
                  styles?.sidebar
                } absolute top-14 -right-[25px] z-10 mx-4 my-2 mr-10 w-[300px] bg-white p-6 lg:top-8`}
              >
                <div className="absolute -top-[5px] left-[50%] h-[12px] w-[12px] origin-center rotate-45 bg-white" />
                <h1 className="mb-[10px] text-[17px] font-[700] text-[#213159]">
                  Mandatory Disclosure
                </h1>
                <ul className="flex flex-1 list-none flex-col items-start justify-end">
                  <div
                    className="font-poppins mb-[5px] cursor-pointer text-[13px] font-medium text-[#696969]"
                    onClick={() => navigate("/campus-tour")}
                  >
                    🎥 Campus Tour
                  </div>
                  {navLinks.map((nav) => (
                    <li
                      key={nav.id}
                      className="font-poppins mb-[5px] cursor-pointer text-[13px] font-medium text-[#696969]"
                    >
                      <p
                        className="hover:text-[#081C3A] font-semibold"
                        onClick={() => {
                          if (nav?.pdf) {
                            window.open(nav?.pdf);
                            return;
                          }
                          if (nav?.form) {
                            window.open(nav?.form);
                            return;
                          }
                          nav.url && navigate(nav?.url);
                          window.scroll(0, 0);
                          setDropDown(false);
                        }}
                      >
                        {nav?.title}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
        {/* --------------------------------============Small Screen===============------------------------------ */}
        <div className="lg:hidden">
          <div
            className={`z-20 flex w-full justify-between  border-b-[1px] p-2 pr-4 pl-6 ${
              !color ? "bg-transparent" : "bg-[#081C3A]"
            } border-[rgba(217,217,218,0.2)] `}
          >
            <div className="relative h-16 w-16 ">
              <Link
                to="/"
                onClick={() => {
                  window.scroll(0, 0);
                  setDropDownOpen(false);
                }}
              >
                <img src={Logo} layout="fill" alt="logo" />
              </Link>
            </div>

            <div className="flex flex-row justify-center items-center">
              <div>
                <SearchBar />
              </div>
              <div
                className=" m-1.5 h-min rounded-md bg-white p-3"
                onClick={() => setDropDownOpen(!dropDownOpen)}
              >
                <FaBars className="fill-[#333333] text-2xl" />
              </div>
            </div>
          </div>
          {/* ------------------------------ */}
          <div className=" h-full overflow-hidden ">
            {dropDownOpen && (
              <motion.div
                initial={{
                  opacity: 0,
                  translateY: -300,
                }}
                animate={{
                  opacity: 1,
                  translateY: 0,
                  height: "100%",
                }}
                transition={{ duratin: 3000 }}
                exit={{ translateY: -300 }}
              >
                {/* -------------------------------- */}
                <div className=" primary-bg-color pb-12 hideScroller   h-[50rem] overflow-y-scroll  py-4 text-white">
                  {/* ── Quick Links (mobile only) ── */}
                  <div className="px-6 pb-2 border-b border-white/20 mb-2">
                    <p className="text-xs text-white/50 uppercase tracking-widest mb-3">Quick Links</p>
                    <div className="flex flex-col gap-3">
                      <a
                        href="tel:+918847262500"
                        className="flex items-center gap-2 bg-yellow-400 text-[#081C3A] font-extrabold px-4 py-2 rounded-full text-sm w-fit"
                      >
                        📞 +91-88472-62500
                      </a>
                      <div
                        className="cursor-pointer text-base font-semibold text-white"
                        onClick={() => { handleAdmission(); setDropDownOpen(false); }}
                      >
                        🎓 Admissions 2026-27
                      </div>
                      <div
                        className="cursor-pointer text-base font-semibold text-white"
                        onClick={() => { handleMentoring(); setDropDownOpen(false); }}
                      >
                        📚 Student Mentoring
                      </div>
                      <div
                        className="cursor-pointer text-base font-semibold text-white"
                        onClick={() => { handleDownload(); setDropDownOpen(false); }}
                      >
                        📄 RTI Disclosure
                      </div>
                      {/* Mandatory Disclosure toggle */}
                      <div>
                        <div
                          className="cursor-pointer text-base font-semibold text-white flex justify-between items-center"
                          onClick={() => setMobileMandatoryOpen(!mobileMandatoryOpen)}
                        >
                          <span>📋 Mandatory Disclosure</span>
                          <span className={`transition-transform duration-200 ${mobileMandatoryOpen ? 'rotate-180' : ''}`}>▾</span>
                        </div>
                        {mobileMandatoryOpen && (
                          <div className="mt-2 ml-4 flex flex-col gap-2 border-l-2 border-white/20 pl-3">
                            <div
                              className="text-sm text-white/80 cursor-pointer hover:text-white py-1"
                              onClick={() => { navigate('/campus-tour'); setDropDownOpen(false); }}
                            >
                              🎥 Campus Tour
                            </div>
                            {navLinks.map((nav, i) => nav?.title && (
                              <div
                                key={i}
                                className="text-sm text-white/80 cursor-pointer hover:text-white py-1"
                                onClick={() => {
                                  if (nav?.pdf) { window.open(nav.pdf); return; }
                                  if (nav?.form) { window.open(nav.form); return; }
                                  if (nav?.url) { navigate(nav.url); setDropDownOpen(false); }
                                }}
                              >
                                {nav.title}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* ── Main Nav ── */}
                  {data?.map((item, idx) => (
                    <div key={idx} className="">
                      <div className=" px-6 text-lg  font-semibold">
                        <div
                          className=" flex justify-between py-[22px]"
                          onClick={() => {
                            window.scroll(0, 0);
                            if (!dropAnim?.includes(item?.id)) {
                              handelDropDown({ e: `${item?.id}` });
                            } else {
                              setDropAnim((current) =>
                                current?.filter(
                                  (element) => element !== item?.id,
                                ),
                              );
                            }
                          }}
                        >
                          <div
                            className="cursor-pointer flex justify-between w-full items-center"
                            onClick={() => {
                              setDropDown(false);

                              window.scroll(0, 0);
                              if (item?.id === "Contact") {
                                navigate("/Contact");
                                setDropDownOpen(false);
                              }
                            }}
                          >
                            <div>{item?.title}</div>
                            <div>
                              {item?.id === "Contact" ? null : (
                                <div className="">
                                  <FiChevronDown className="text-2xl" />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {item?.subCat?.map((el, idx) => (
                          <div className="" key={idx}>
                            {dropAnim?.includes(item?.id) && (
                              <motion.div
                                initial={{
                                  opacity: 0.6,
                                  translateY: -20,
                                  scaleX: 0.8,
                                  scaleY: 0.6,
                                }}
                                transition={{ duratin: 3000 }}
                                animate={{
                                  opacity: 1,
                                  translateY: 0,
                                  scaleX: 1,
                                  scaleY: 1,
                                }}
                                exit={{
                                  opacity: 0.6,
                                  translateY: -20,
                                  scaleX: 0.8,
                                  scaleY: 0.6,
                                }}
                                className="focus:bg-accent cursor-pointer rounded-xl px-3 py-2 outline-none"
                              >
                                <div
                                  className=" text-md font-medium"
                                  onClick={() => window.scroll(0, 0)}
                                >
                                  <div className="secondary-color mb-4 text-2xl font-semibold ">
                                    {el?.subTitle}
                                  </div>
                                  {el?.SubHeadings?.map((elm) => (
                                    <div
                                      className="primary-bg-color mb-6"
                                      key={elm?.path}
                                      onClick={() => {
                                        if (elm?.redirect) {
                                          window.open(elm?.redirect);
                                          return;
                                        }
                                        setDropDownOpen(false);
                                        navigate(elm?.path || "/");
                                      }}
                                    >
                                      <div className="">{elm?.Link}</div>
                                    </div>
                                  ))}
                                </div>
                              </motion.div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </motion.div>
            )}
          </div>
        </div>
        <div className="hidden lg:block">
          <DesktopHeader />
        </div>
      </div>
    </div>
  );
};

export default Header;
